import { DatePicker } from '@mantine/dates'
import dayjs from 'dayjs'
import React, { useEffect, useState } from 'react'
import { useRange } from 'react-instantsearch'
import { Box } from 'components/Layout'
import { FilterCollapsibleItem } from './FilterCollapsibleItem'

type FilterCollapsibleDateRangeProps = {
  title: string
  defaultOpened?: boolean
  attribute: string
}

export const FilterCollapsibleDateRange = ({
  title,
  defaultOpened,
  attribute,
}: FilterCollapsibleDateRangeProps) => {
  const { start, range, canRefine, refine } = useRange({ attribute })
  const { min, max } = range

  const from = Math.max(min, Number.isFinite(start[0]) ? start[0] : min)
  const to = Math.min(max, Number.isFinite(start[1]) ? start[1] : max)

  const [value, setValue] = useState<[Date, Date]>([
    dayjs(from * 1000, {
      utc: true,
    }).toDate(),
    dayjs(to * 1000, {
      utc: true,
    }).toDate(),
  ])

  useEffect(() => {
    setValue([
      dayjs(from * 1000, { utc: true }).toDate(),
      dayjs(to * 1000, { utc: true }).toDate(),
    ])
  }, [from, to])

  if (!canRefine) {
    return null
  }

  const handleChange = (newRange: [any | null, any | null]) => {
    setValue((previous) => {
      if (
        newRange[0] &&
        newRange[1] &&
        (previous[0] !== newRange[0] || previous[1] !== newRange[1])
      ) {
        const startOfDay = dayjs(newRange[0]).startOf('day')
        const endOfDay = dayjs(newRange[1]).endOf('day')

        refine([startOfDay.unix(), endOfDay.unix()])
      }
      return newRange
    })
  }

  return (
    <FilterCollapsibleItem title={title} defaultOpened={defaultOpened}>
      <Box>
        <DatePicker
          type="range"
          value={value}
          onChange={handleChange}
          allowSingleDateInRange
          firstDayOfWeek={0}
          minDate={dayjs(min * 1000).toDate()}
        />
      </Box>
    </FilterCollapsibleItem>
  )
}
